module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('section', {
    staticClass: "settings-section"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('MY_ACCOUNT')))]), _vm._v(" "), _c('div', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 overflow-hidden"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('EMAIL_ADDRESS_COLON')))]), _vm._v(" "), _c('p', {
    staticClass: "text-bold",
    style: ({
      'font-size': _vm.emailFontSize
    })
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('PASSWORD_COLON')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "arrow-link",
    on: {
      "click": function($event) {
        _vm.showSetNewPasswordModal = true
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('CHANGE_PASSWORD')) + "\n                "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "arrow-link",
    on: {
      "click": function($event) {
        _vm.showDeactivateAccountModal = true
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('DEACTIVATE_ACCOUNT')) + "\n                "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])])]), _vm._v(" "), (_vm.user.address && _vm.user.address.country) ? _c('div', [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('SHARING_DOCUMENTATION_TO_DOCTOR')))]), _vm._v(" "), _c('div', {
    staticClass: "row margin-bottom"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('DOCTOR_OR_SOMEONE_ELSE_DATA')))])]), _vm._v(" "), (!_vm.showDoctorForm) ? _c('div', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('I_DO_NOT_WANT_TO_SHARE_DOCUMENTATION')))])]), _vm._v(" "), _c('button', {
    staticClass: "arrow-link",
    staticStyle: {
      "padding-top": "15px"
    },
    on: {
      "click": function($event) {
        _vm.showDoctorForm = true
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('CHANGE')) + "\n                    "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showDoctorForm) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addTrustedDoctor.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^.+ .+$/
      }),
      expression: "{ required: true, regex: /^.+ .+$/ }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedDoctor.name),
      expression: "trustedDoctor.name"
    }],
    staticClass: "text-input white-input-border",
    attrs: {
      "type": "text",
      "name": _vm.$t('NAME'),
      "placeholder": _vm.$t('NAME')
    },
    domProps: {
      "value": (_vm.trustedDoctor.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedDoctor, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.emailRegex
      }),
      expression: "{ required: true, regex: emailRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedDoctor.email),
      expression: "trustedDoctor.email"
    }],
    staticClass: "text-input white-input-border",
    attrs: {
      "type": "email",
      "name": _vm.$t('EMAIL_ADDRESS'),
      "placeholder": _vm.$t('EMAIL_ADDRESS')
    },
    domProps: {
      "value": (_vm.trustedDoctor.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedDoctor, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary"
  }, [_vm._v(_vm._s(_vm.$t('ADD_PERSON')))])])]) : _vm._e(), _vm._v(" "), (_vm.trustedDoctors) ? _c('div', {
    staticClass: "data-details"
  }, [_c('div', {
    staticClass: "col-xs-12 mt-5"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.trustedDoctors
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('EMPTY_LIST')))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "text-break"
        }, [_vm._v(_vm._s(((_vm.$t('NAME_COLON')) + " " + (scope.row.name))))]), _vm._v(" "), _c('p', {
          staticClass: "text-break"
        }, [_vm._v("\n                                    " + _vm._s(((_vm.$t('EMAIL_ADDRESS_COLON')) + " " + (scope.row.email))) + "\n                                ")]), _vm._v(" "), (scope.row.dateRemoved == null) ? _c('div', [_c('el-button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeTrustedDoctor(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('DELETE')))])], 1) : _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$t('PERMISSION_DELETED')) + "\n                                    " + _vm._s(_vm.dateFormat(scope.row.dateRemoved)) + "\n                                ")])]
      }
    }], null, false, 1575371372)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('NAME')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('EMAIL_ADDRESS')
    }
  }), _vm._v(" "), (!_vm.clientWidthIsSmall) ? _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dateRemoved == null) ? _c('div', [_c('el-button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeTrustedDoctor(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('DELETE')))])], 1) : _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$t('PERMISSION_DELETED')) + "\n                                    " + _vm._s(_vm.dateFormat(_vm.mapDateToUserTimezone(scope.row.dateRemoved))) + "\n                                ")])]
      }
    }], null, false, 3891135053)
  }) : _vm._e()], 1)], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showDeactivateAccountModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showDeactivateAccountModal = false
      }
    }
  }, [_c('deactivate-account', {
    on: {
      "close": function($event) {
        _vm.showDeactivateAccountModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSetNewPasswordModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showSetNewPasswordModal = false
      }
    }
  }, [_c('set-new-password', {
    on: {
      "close": function($event) {
        _vm.showSetNewPasswordModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.accountTypeIsPro) ? [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('SHARING_DOCUMENTATION')))]), _vm._v(" "), _c('div', {
    staticClass: "row margin-bottom"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('SHARING_DOCUMENTATION_INFO')))])]), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "trustedPerson"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addTrustedPerson.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-3 pl-3 pr-0 sm-no-padding"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^.+ .+$/
      }),
      expression: "{ required: true, regex: /^.+ .+$/ }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedPerson.name),
      expression: "trustedPerson.name"
    }],
    staticClass: "text-input white-input-border",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "text",
      "name": _vm.$t('NAME'),
      "placeholder": _vm.$t('NAME')
    },
    domProps: {
      "value": (_vm.trustedPerson.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedPerson, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 pr-0 mr-0 sm-no-padding"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.emailRegex
      }),
      expression: "{ required: true, regex: emailRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedPerson.email),
      expression: "trustedPerson.email"
    }],
    staticClass: "text-input white-input-border",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "email",
      "name": _vm.$t('EMAIL_ADDRESS'),
      "placeholder": _vm.$t('EMAIL_ADDRESS')
    },
    domProps: {
      "value": (_vm.trustedPerson.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedPerson, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 pr-0 pl-4 sm-no-padding"
  }, [_c('el-select', {
    staticClass: "-white-input-border directional-number-custom",
    staticStyle: {
      "height": "50px"
    },
    model: {
      value: (_vm.trustedPerson.dialingCode),
      callback: function($$v) {
        _vm.$set(_vm.trustedPerson, "dialingCode", $$v)
      },
      expression: "trustedPerson.dialingCode"
    }
  }, _vm._l((_vm.directionalNumbers), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pr-4 sm-no-padding"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedPerson.phoneNumber),
      expression: "trustedPerson.phoneNumber"
    }],
    staticClass: "text-input white-input-border",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "text",
      "name": _vm.$t('PHONE_NUMBER'),
      "placeholder": _vm.$t('PHONE_NUMBER')
    },
    domProps: {
      "value": (_vm.trustedPerson.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedPerson, "phoneNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 label-above"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary"
  }, [_vm._v(_vm._s(_vm.$t('ADD_PERSON')))])])]), _vm._v(" "), (_vm.trustedPeople) ? _c('div', {
    staticClass: "data-details"
  }, [_c('div', {
    staticClass: "col-xs-12 mt-5"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.trustedPeople
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('EMPTY_LIST')))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "text-break"
        }, [_vm._v(_vm._s(((_vm.$t('NAME_COLON')) + " " + (scope.row.name))))]), _vm._v(" "), _c('p', {
          staticClass: "text-break"
        }, [_vm._v(_vm._s(((_vm.$t('EMAIL_ADDRESS_COLON')) + " " + (scope.row.email))))]), _vm._v(" "), _c('p', {
          staticClass: "text-break"
        }, [_vm._v("\n                                    " + _vm._s(((_vm.$t('PHONE_NUMBER_COLON')) + " " + (scope.row.dialingCode != null ? scope.row.dialingCode : '') + " " + (scope.row.phoneNumber))) + "\n                                ")]), _vm._v(" "), (scope.row.dateRemoved == null) ? _c('div', [_c('el-button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeTrustedPerson(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('DELETE')))])], 1) : _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$t('PERMISSION_DELETED')) + "\n                                    " + _vm._s(_vm.dateFormat(scope.row.dateRemoved)) + "\n                                ")])]
      }
    }], null, false, 1433978251)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('NAME')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('EMAIL_ADDRESS')
    }
  }), _vm._v(" "), (!_vm.clientWidthIsSmall) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('PHONE_NUMBER')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(((scope.row.dialingCode != null ? scope.row.dialingCode : '') + " " + (scope.row.phoneNumber))) + "\n                            ")]
      }
    }], null, false, 473705024)
  }) : _vm._e(), _vm._v(" "), (!_vm.clientWidthIsSmall) ? _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dateRemoved == null) ? _c('div', [_c('el-button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeTrustedPerson(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('DELETE')))])], 1) : _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$t('PERMISSION_DELETED')) + "\n                                    " + _vm._s(_vm.dateFormat(_vm.mapDateToUserTimezone(scope.row.dateRemoved))) + "\n                                ")])]
      }
    }], null, false, 592607289)
  }) : _vm._e()], 1)], 1)]) : _vm._e()]), _vm._v(" "), (_vm.user.address && _vm.user.address.country && _vm.user.address.country.code === 'IE') ? [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('SHARING_DOCUMENTATION_TO_DOCTOR')))]), _vm._v(" "), _c('div', {
    staticClass: "row margin-bottom"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('DOCTOR_OR_SOMEONE_ELSE_DATA')))])]), _vm._v(" "), (!_vm.showDoctorForm) ? _c('div', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('I_DO_NOT_WANT_TO_SHARE_DOCUMENTATION')))])]), _vm._v(" "), _c('button', {
    staticClass: "arrow-link",
    staticStyle: {
      "padding-top": "15px"
    },
    on: {
      "click": function($event) {
        _vm.showDoctorForm = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('CHANGE')) + "\n                        "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showDoctorForm) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addTrustedDoctor.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^.+ .+$/
      }),
      expression: "{ required: true, regex: /^.+ .+$/ }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedDoctor.name),
      expression: "trustedDoctor.name"
    }],
    staticClass: "text-input white-input-border",
    attrs: {
      "type": "text",
      "name": _vm.$t('NAME'),
      "placeholder": _vm.$t('NAME')
    },
    domProps: {
      "value": (_vm.trustedDoctor.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedDoctor, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.emailRegex
      }),
      expression: "{ required: true, regex: emailRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedDoctor.email),
      expression: "trustedDoctor.email"
    }],
    staticClass: "text-input white-input-border",
    attrs: {
      "type": "email",
      "name": _vm.$t('EMAIL_ADDRESS'),
      "placeholder": _vm.$t('EMAIL_ADDRESS')
    },
    domProps: {
      "value": (_vm.trustedDoctor.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trustedDoctor, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary"
  }, [_vm._v(_vm._s(_vm.$t('ADD_PERSON')))])])]) : _vm._e(), _vm._v(" "), (_vm.trustedDoctors) ? _c('div', {
    staticClass: "data-details"
  }, [_c('div', {
    staticClass: "col-xs-12 mt-5"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.trustedDoctors
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('EMPTY_LIST')))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "text-break"
        }, [_vm._v(_vm._s(((_vm.$t('NAME_COLON')) + " " + (scope.row.name))))]), _vm._v(" "), _c('p', {
          staticClass: "text-break"
        }, [_vm._v("\n                                        " + _vm._s(((_vm.$t('EMAIL_ADDRESS_COLON')) + " " + (scope.row.email))) + "\n                                    ")]), _vm._v(" "), (scope.row.dateRemoved == null) ? _c('div', [_c('el-button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeTrustedDoctor(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('DELETE')))])], 1) : _c('div', [_vm._v("\n                                        " + _vm._s(_vm.$t('PERMISSION_DELETED')) + "\n                                        " + _vm._s(_vm.dateFormat(scope.row.dateRemoved)) + "\n                                    ")])]
      }
    }], null, false, 12476524)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('NAME')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('EMAIL_ADDRESS')
    }
  }), _vm._v(" "), (!_vm.clientWidthIsSmall) ? _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dateRemoved == null) ? _c('div', [_c('el-button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeTrustedDoctor(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('DELETE')))])], 1) : _c('div', [_vm._v("\n                                        " + _vm._s(_vm.$t('PERMISSION_DELETED')) + "\n                                        " + _vm._s(_vm.dateFormat(_vm.mapDateToUserTimezone(scope.row.dateRemoved))) + "\n                                    ")])]
      }
    }], null, false, 1150189901)
  }) : _vm._e()], 1)], 1)]) : _vm._e()])] : _vm._e()] : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "margin-bottom"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('PATIENT_ACCOUNT_LANG')))]), _vm._v(" "), _c('language-selection', {
    staticClass: "col-xs-12 mb-5 mt-2",
    attrs: {
      "single": true
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('AGREEMENTS')))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('REGISTRY_NEWSLETTER_AGREEMENT'),
      "hide-details": "",
      "color": "main-color"
    },
    on: {
      "change": _vm.updateUserAgreements
    },
    model: {
      value: (_vm.commercialInformationAgreement),
      callback: function($$v) {
        _vm.commercialInformationAgreement = $$v
      },
      expression: "commercialInformationAgreement"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('MARKETING_INFORMATION_AGREEMENT'),
      "hide-details": "",
      "color": "main-color"
    },
    on: {
      "change": _vm.updateUserAgreements
    },
    model: {
      value: (_vm.marketingAgreement),
      callback: function($$v) {
        _vm.marketingAgreement = $$v
      },
      expression: "marketingAgreement"
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5281e3a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/settings/settings.vue
// module id = 1201
// module chunks = 0